module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-3-128.b6b5d2a5ad61a2c1.jpg"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-3-128.b6b5d2a5ad61a2c1.jpg",width: 128,height: 85}],
        src: "https://static.sniffspot.com/packs/img/bp-3-128.b6b5d2a5ad61a2c1.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-3-128.b6b5d2a5ad61a2c1.jpg"},
        
        width: 128,
        height: 85
      }